import { render } from "./StoryList.vue?vue&type=template&id=2e6f5e56&scoped=true&bindings={\"stories\":\"setup\",\"completeStory\":\"setup\",\"layout\":\"setup\",\"sortKey\":\"setup\",\"sortOrder\":\"setup\",\"sortField\":\"setup\",\"showUnselected\":\"setup\",\"sortOptions\":\"data\",\"onSortChange\":\"options\",\"handleChange\":\"options\"}"
import script from "./StoryList.vue?vue&type=script&lang=js"
export * from "./StoryList.vue?vue&type=script&lang=js"

import "./StoryList.vue?vue&type=style&index=0&id=2e6f5e56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e6f5e56"

export default script